import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';

const ComparePlansLink = () => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    align: "center",
    children: [/*#__PURE__*/_jsx(UILink, {
      onClick: () => document.querySelector('#compare-plans').scrollIntoView(),
      id: "compare-plans",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.suiteStarter.compare",
        className: "m-bottom-2"
      })
    }), /*#__PURE__*/_jsx(UIIcon, {
      name: "next",
      size: "xxs",
      style: {
        transform: 'rotateZ(90deg)',
        margin: '8px 0'
      },
      color: CALYPSO_DARK
    })]
  });
};

export default ComparePlansLink;